module.exports = __webpack_public_path__ + "static/overlay-b4a5521a1acd7ed97613e8d6992d7547.png";